import React, { useState } from "react"
import clsx from "clsx"
import { useWindowSize } from "react-use"
import S from "./product-index.module.scss"
import FilterIcon from "../svgs/feather-filter.svg"
import XIcon from "../svgs/x.svg"
import NoResults from "@/components/no-results"
import Pagination from "@/components/pagination"
import ProductBox from "@/components/product-box"
import ProductFiltersGroup from "@/components/product-filters-group"
import { Category, ProductsPaginated, SubCategory } from "@/types"

type Props = {
  products: ProductsPaginated
  basePath?: string
  rawPath?: string
  filters?: { categories?: Category }
  // eslint-disable-next-line react/no-unused-prop-types
  currentCategory?: SubCategory
}

const ProductIndex: React.FC<Props> = ({
  products,
  rawPath,
  basePath,
  filters = undefined,
}) => {
  const [openedFilters, setOpenedFilters] = useState<boolean>(false)
  const { width } = useWindowSize()

  const actuallyOpenedFilters = width > 992 || openedFilters

  if (products.meta.total === 0) {
    return <NoResults />
  }

  return (
    <section className="bg-gray u-section-padding-md">
      <div className="container">
        <div className="row">
          {filters && filters.categories && (
            <div className="col-lg-3">
              <div className={S.filters}>
                <div className="row align-items-center mb-4 mb-lg-5">
                  <div className="col">
                    <p className="u-section-title m-0">Filters</p>
                  </div>
                  <div className="col-auto d-lg-none">
                    <button
                      type="button"
                      className={S.toggleButton}
                      onClick={() => setOpenedFilters(!openedFilters)}
                    >
                      {openedFilters ? <XIcon /> : <FilterIcon />}
                    </button>
                  </div>
                </div>
                {actuallyOpenedFilters && (
                  <>
                    {/* {currentCategory && */}
                    {/*  currentCategory.component_types.length > 0 && ( */}
                    {/*    <ProductFiltersGroup */}
                    {/*      basePath={`/${rawPath}/category/${currentCategory.slug}/type`} */}
                    {/*      values={currentCategory.component_types} */}
                    {/*      title="Component Type" */}
                    {/*    /> */}
                    {/*  )} */}
                    <ProductFiltersGroup
                      basePath={rawPath ? `/${rawPath}/category` : "/category"}
                      values={filters.categories.sub_categories}
                    />
                  </>
                )}
              </div>
            </div>
          )}
          <div className="separator d-lg-none mt-2 mb-4" />
          <div className="col-lg">
            <div className="row no-gutters my-md-n3">
              {products.data.map((item) => (
                <div
                  className={clsx("col-12", {
                    "col-md-4": filters,
                    "col-md-3": !filters,
                  })}
                  key={item.id}
                >
                  <ProductBox data={item} className="h-100" />
                </div>
              ))}
            </div>

            <Pagination
              className="mt-5"
              basePath={basePath}
              currentPage={products.meta.current_page}
              lastPage={products.meta.last_page}
            />
          </div>
        </div>
      </div>
    </section>
  )
}

export default ProductIndex
